export type PostponeCheckRequest = {
  installmentCardId: string;
  /** IRR the payment was collected on, so an assigned installment's postpone is recorded there. */
  irrId?: string;
  /** Called after an installment is postponed, so the page can reload. */
  onPostponed?: () => void;
};

type Listener = () => void;

let current: PostponeCheckRequest | null = null;
let version = 0;
const listeners = new Set<Listener>();

const notify = () => {
  for (const listener of listeners) listener();
};

/** Ask the app-level prompt host to check this card for an installment to postpone. */
export function requestPostponeCheck(request: PostponeCheckRequest): void {
  const installmentCardId = String(request.installmentCardId ?? '').trim();
  if (!installmentCardId) return;
  current = { ...request, installmentCardId };
  version += 1;
  notify();
}

export function clearPostponeCheck(): void {
  if (!current) return;
  current = null;
  version += 1;
  notify();
}

export function subscribePostponeCheck(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

let snapshot: { request: PostponeCheckRequest | null; version: number } = { request: null, version: 0 };

/** Snapshot for useSyncExternalStore; a new version means a new request even for the same card. */
export function getPostponeCheck(): { request: PostponeCheckRequest | null; version: number } {
  if (snapshot.version !== version) snapshot = { request: current, version };
  return snapshot;
}
